import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import {
  Loading,
  PageHeader,
  CustomPanel,
  CustomModal,
  InputText,
  Btn,
  CustomDataTableHeader,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as TipoVeiculoHttp from '../../../../services/api/https/registration/tipo-veiculo.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

const TipoVeiculo = ({ history, dispatch }) => {
  const [tipos, setTipos] = useState([])
  const [modal, setModal] = useState({ show: false, data: null })
  const [isLoanding, setIsLoading] = useState(true)

  // Events
  const onBtnNovo = () => {
    setModal({ show: true, data: null })
  }
  const onBtnVoltar = () => {
    history.goBack()
  }
  const onModalClose = () => {
    setModal({ show: false, data: null })
  }
  const onModalSave = async tipo => {
    try {
      const savedTipo = await TipoVeiculoHttp.saveTipoVeiculo(tipo)

      const index = tipos.findIndex(t => t.id === savedTipo.id)
      if (index !== -1) {
        tipos[index] = savedTipo
      } else {
        tipos.push(savedTipo)
      }
      setTipos(tipos)
      setModal({ show: false, data: null })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  const onDataTableItemClicked = tipo => {
    setModal({ show: true, data: tipo })
  }

  // Hooks
  useEffect(() => {
    _getTiposVeiculos()
  }, [])

  // Helpers
  const _getTiposVeiculos = async () => {
    try {
      const tipos = await TipoVeiculoHttp.getTiposVeiculos()
      setTipos(tipos)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>2.12 - Tipos de Veículos</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={onBtnVoltar}>
          {isLoanding ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <TipoVeiculoDatatable tipos={tipos} onItemClicked={onDataTableItemClicked} />
          )}
        </CustomPanel>
      </div>
      {modal.show ? (
        <TipoVeiculoModal
          show={modal.show}
          onModalClose={onModalClose}
          onModalSave={onModalSave}
          data={modal.data}
        />
      ) : null}
    </div>
  )
}

const TipoVeiculoDatatable = ({ tipos, onItemClicked }) => {
  const [globalFilter, setGlobalFilter] = useState('')

  const onBtnExportarExcelClick = tipo_veiculos => {
    const colunas = [['Nome']]

    tipo_veiculos.forEach(t => {
      colunas.push([t.manufacturer_type])
    })

    gerarArquivoExcel('Tipos de Veículos', colunas, 'tipo_veiculos.xlsx')
  }

  const onChangeGlobalFilter = value => {
    setGlobalFilter(value)
  }

  const header = (
    <CustomDataTableHeader onChange={onChangeGlobalFilter}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => onBtnExportarExcelClick(tipos)}>Exportar</Btn>
      </div>
    </CustomDataTableHeader>
  )
  return (
    <DataTable
      value={tipos}
      selectionMode="single"
      onSelectionChange={e => onItemClicked(e.value)}
      header={header}
      paginator={true}
      rows={10}
      globalFilter={globalFilter}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="manufacturer_type" header="Tipo de Veículo" />
    </DataTable>
  )
}

const TipoVeiculoModal = ({ show, onModalClose, onModalSave, data }) => {
  const [tipo, setTipo] = useState({
    id: data ? data.id : null,
    manufacturer_type: data ? data.manufacturer_type : '',
  })
  return (
    <CustomModal header="Tipo de Veículo" isVisible={show} onClose={onModalClose}>
      <form className="p-grid">
        <div className="p-col-12">
          <InputText
            label="Descrição - Tipo de Veículo"
            value={tipo.manufacturer_type}
            onChange={value => setTipo({ ...tipo, manufacturer_type: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => onModalSave(tipo)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(withRouter(TipoVeiculo))
